/**
 * 全局基础配置
 */
// 全局变量通过define-plugin注入
const envDebug = process.env.ENV_DEBUG; // 本地调试
export const envName = process.env.ENV_NAME; // 环境变量

export const APP_NAME = process.env.APP_NAME || '';
export const ENV_BASE = process.env.ENV_BASE || '';
// H5：jojo
export const isJoJo = APP_NAME === '';
// H5：jojoup
export const isJoJoUp = APP_NAME === 'jojoup';
// H5：矩阵
export const isMatrix = APP_NAME === 'matrix';
export const appName = isJoJoUp ? 'JOJOUP' : '叫叫';

export const JOJO_READ_URL = process.env.JOJO_READ_URL || `https://jojoread.${envName}.tinman.cn`;

export const LOCAL_BASE_URL = isJoJoUp
  ? `${window.location.origin}/mall/center`
  : window.location.origin;

// 是否调试模式，区别非正式环境
export const DEBUG = !!envName && envName !== 'pro';
// 是否开启本地调试
export const DEBUG_LOCAL = envDebug;

// 模拟调试header信息，跳过授权检测
export const DEBUG_HEADER_INFO = envDebug
  ? {
      // 'X-UAGW-userId': 31696,
      'X-UAGW-userId': envName === 'fat' ? 101003113 : 70010268,
      // 'X-UAGW-userId': 28163,
      // 'X-UAGW-userId': 27277,
      // 'X-UAGW-userId': 30737,
      'X-UAGW-authMode': 1
    }
  : {};
//
// TODO NOTICE:  服务器地址需经过环境变量处理不建议直接导出
// 服务器端接口地址
export const envs = ['fat', 'uat', 'dev', 'qa', 'pro'];

if (!envName || !envs.includes(envName)) {
  throw new Error('环境变量ENV_NAME不存在');
}
const env = DEBUG ? `.${envName}` : '';

const jojoUpEnv = DEBUG ? `-${envName}` : '';

/* function envFactory(key) {
  const allEnv = process.env.ALL_ENV || {};
  return allEnv[key];
} */

/**
 * 商城前端域名
 */
export const MALL_FROUNT_URL = `https://mall${env}.tinman.cn`;
/**
 * 商城前端域名: jojoup
 */
export const JOJOUP_FROUNT_URL = `https://pages${jojoUpEnv}.mohezi.cn`;
/**
 * 商城前端域名: 矩阵
 */
export const MATRIX_FROUNT_URL = `https://mall${jojoUpEnv}.cdssylkj.com`;
/**
 * 商城前端域名 origin
 */
export const MALL_FROUNT_ORIGIN_URL = isJoJoUp
  ? `${JOJOUP_FROUNT_URL}/mall/center`
  : isMatrix
  ? MATRIX_FROUNT_URL
  : MALL_FROUNT_URL;

/**
 * 商城服务基础域名
 */
export const MALL_SERVICE_BASE = isJoJoUp
  ? `https://pages${jojoUpEnv}.mohezi.cn`
  : isMatrix
  ? `https://api${jojoUpEnv}.cdssylkj.com`
  : `https://api${env}.tinman.cn`;

/**
 * 商城服务基础域名
 */
const MALL_SERVICE_URL_BASE =
  process.env.MALL_SERVICE_URL_BASE || isMatrix
    ? `https://api-${envName}.cdssylkj.com/mall`
    : `https://api${env}.tinman.cn/mall`;

/**
 * 各服务具体名称
 */
const MALL_ORDER_PAY_URL = process.env.MALL_ORDER_PAY_URL || `${MALL_SERVICE_URL_BASE}/order`;

const MALL_BASE_URL = process.env.MALL_BASE_URL || `${MALL_SERVICE_URL_BASE}/product/api/fe`;
// const MALL_BASE_URL = `http://10.128.8.228:8081/api/fe`;
export const ORDER_BASE_URL = process.env.ORDER_BASE_URL || `${MALL_SERVICE_URL_BASE}/order`;
const PAY_BASE_URL = process.env.PAY_BASE_URL || `${MALL_SERVICE_URL_BASE}/pay`;
const DELIVERY_BASE_URL =
  process.env.DELIVERY_BASE_URL || `${MALL_SERVICE_URL_BASE}/delivery/api/fe`;
const REDEEMCODE_BASE_URL =
  process.env.REDEEMCODE_BASE_URL || `${MALL_SERVICE_URL_BASE}/redeemcode/api/fe`;
const COUPON_BASE_URL =
  process.env.COUPON_BASE_URL || `${MALL_SERVICE_URL_BASE}/coupon/api/coupon/fe`;
const ADVERTISE_BASE_URL =
  process.env.ADVERTISE_BASE_URL || `https://fb${env}.tinman.cn/api/jaguar`;
const BOOM_BASE_URL = process.env.BOOM_BASE_URL || `https://api${env}.tinman.cn/api/boom/fe`;

// ab测试接口
const AB_TEST_BASE_URL = ` ${
  isMatrix ? `https://api${jojoUpEnv}.cdssylkj.com` : `https://api${env}.tinman.cn`
}/flagd.evaluation.v1.Service`;

// shine
const SHINE_BASE_URL = process.env.SHINE_BASE_URL || `https://api${env}.tinman.cn/api/shine/fe`;
const NEW_SHINE_BASE_URL = process.env.NEW_SHINE_BASE_URL || SHINE_BASE_URL.replace('/fe', '');

// const SHINE_BASE_URL = `http://172.17.0.142:8080/api/shine/fe`;
const CASHBACK_BASE_URL =
  process.env.CASHBACK_BASE_URL || `https://api${env}.tinman.cn/mall/cashback`;

const FE_BOOM_BASE_URL = process.env.FE_BOOM_BASE_URL || `https://boom${env}.tinman.cn`;

const QUOTA_BASE_URL =
  process.env.QUOTA_BASE_URL || `https://api${env}.tinman.cn/mall/quota-open-api`;

export const uc_switch = process.env.UC_SWITCH;

// 发票列表需要跳转的页面前缀
const MALL_ORDER_BASE_URL = `https://mall${env}.tinman.cn/order`;

// 智齿客服地址 免鉴权
const JING_TAN_NO_AUTH_URL = isJoJoUp
  ? `https://api.mohezi.cn/fb/pagani/api/pagani/view/jingtan/chat`
  : `https://api${env}.tinman.cn/api/pagani/view/jingtan/chat`;
// 智齿客服地址 需要鉴权
const JING_TAN_NEED_AUTH_URL = `https://jojoread${env}.tinman.cn/page/jingtan/view/chat`;

export const FE_ACT_BASE_URL = process.env.FE_ACT_BASE_URL || `https://act${env}.tinman.cn`;
/*
 * landing活动页面 baseUrl
 */
export const LANDING_BASE_URL = isJoJoUp
  ? `${window.location.origin}/mall/landing/jojoup`
  : `${FE_ACT_BASE_URL}/act2/qwerty`;

/*
 * 营销页面 baseUrl
 */
export const MARKETING_BASE_URL = isJoJoUp
  ? `${window.location.origin}/mall/market`
  : FE_ACT_BASE_URL;

/*
 * 增长激活码手动兑换页面
 */
export const ACT_ACTIVE_CODE_URL = `${MARKETING_BASE_URL}/activeCode/index`;

//暂时不考虑jojoup，成长豆规则用到的地址未部署jojoup
export const JOJOREAD_BASEURL = `https://jojoread${env}.tinman.cn`;
/**
 * 增长加班中转页
 */
export const ACT_ORDER_TRANSFER_URL = `${FE_ACT_BASE_URL}${
  isJoJoUp ? '/orderTransfer.html' : '/act2/17xlpt/orderTransfer.html'
}`;

// 激活码激活页面地址
const EXCHANGE_URL = {
  fat: 'https://edu.fat.tinman.cn/active-process',
  qa: 'https://edu-qa.fat.tinman.cn/active-process',
  uat: 'https://edu.uat.tinman.cn/active-process',
  pro: 'https://edu.tinman.cn/active-process',
  dev: 'https://edu.dev.tinman.cn/active-process'
};

// 激活码激活页面阅读地址
const EXCHANGE_JOJO_URL = {
  fat: 'https://jojoread.fat.tinman.cn/page/courseGuide/view/activateClassSuccess?activateUserCourseIdStr=${activateUserCourseIdStr}',
  qa: 'https://jojoread.qa.tinman.cn/page/courseGuide/view/activateClassSuccess?activateUserCourseIdStr=${activateUserCourseIdStr}',
  uat: 'https://jojoread.uat.tinman.cn/page/courseGuide/view/activateClassSuccess?activateUserCourseIdStr=${activateUserCourseIdStr}',
  pro: 'https://jojoread.tinman.cn/page/courseGuide/view/activateClassSuccess?activateUserCourseIdStr=${activateUserCourseIdStr}',
  dev: 'https://jojoread.dev.tinman.cn/page/courseGuide/view/activateClassSuccess?activateUserCourseIdStr=${activateUserCourseIdStr}'
};
// 已激活页面地址
const EXCHANGE_ACTIVED_URL = {
  pro: 'https://edu.tinman.cn/active/to-activated',
  fat: 'https://edu.fat.tinman.cn/active/to-activated',
  qa: 'https://edu-qa.fat.tinman.cn/active/to-activated'
};

// cms专辑页面地址
const CMS_DETAIL_URL = {
  dev: 'hhttps://jojoread.dev.tinman.cn/web/tellStories/groupon-redirect-page',
  fat: 'https://jojoread.fat.tinman.cn/web/tellStories/groupon-redirect-page',
  uat: 'https://jojoread.uat.tinman.cn/web/tellStories/groupon-redirect-page',
  pro: 'https://jojoread.tinman.cn/web/tellStories/groupon-redirect-page'
};

// 子账号解绑调用 TODO:区分环境
const UNBIND_URL = {
  pro: 'https://jojoread.tinman.cn/page/userSubAccount/view/bind',
  fat: 'https://jojoread.tinman.cn/beta/page/userSubAccount/view/bind',
  dev: 'https://jojoread.tinman.cn/beta/page/userSubAccount/view/bind'
};
// 授权失效之后进入链接地址
export const AUTH_SIGN_URL =
  process.env.AUTH_SIGN_URL || 'https://uc-api.tinman.cn/page/wechatMp/portal/entrance';

// 客服链接,使用的飞鲸客服聊天
const SUPPORT_BASE_URL = process.env.SUPPORT_BASE_URL || 'https://jojoread.tinman.cn';
// const SUPPORT_DEBUG_BASE_URL = DEBUG_LOCAL ? '' : SUPPORT_BASE_URL;

// UC授权地址
export const UC_DEBUG_API_DOMAIN =
  process.env.UC_DEBUG_API_DOMAIN || `https://uc-api.${envName}.tinman.cn`;
export const UC_API_DOMAIN = process.env.UC_API_DOMAIN || 'https://uc-api.tinman.cn';

// UC授权地址（本地配置）
const UC_DEBUG_BASE_API_DOMAIN = `https://uc-api.${envName}.tinman.cn`;
const UC_BASE_API_DOMAIN = 'https://uc-api.tinman.cn';

export const SUPPORT_CHAT_URL =
  process.env.SUPPORT_CHAT_URL ||
  '//chat.jd.com/index.action?source=open_web&aspid=18263598730.1.3.0.1751.2&mallId=18263598730&userApp=open.19488bf0a16431ebbb300183de.customer&waiterAppId=open.19488bf0a16431ebbb300183de.waiter';
export const supportBaseURL = SUPPORT_BASE_URL; // 现在阅读通过网络方式切换
export const advertiseBaseUrl = ADVERTISE_BASE_URL;
export function envPath(name = envName) {
  return name === 'pro' ? '' : `.${name}`;
}
/**
 * 高德地图
 */
export const GAODE_MAP = {
  key: '58839b048067f50763de692640d7f583', // 申请好的Web端开发者Key，首次调用 load 时必填
  securityJsCode: '0b52e760fa1a12be0fdf9337b21d656c' // 谷歌地图安全密钥
};

const jojoAccountConfigs = {
  jojoup: {
    envName,
    hosts: {
      ucHost: `${UC_API_DOMAIN}`,
      serverHost: `${JOJO_READ_URL}`,
      apiHost: window.location.origin
    }
  },
  jojo: { envName },
  matrix: {
    envName,
    hosts: {
      ucHost: UC_API_DOMAIN,
      serverHost: window.location.origin,
      apiHost: UC_API_DOMAIN
    }
  }
};

export const jojoAccountConfig = jojoAccountConfigs[APP_NAME || 'jojo'];
/**
 * 叫叫小程序appid
 */
export const jojoMiniappId = {
  test: 'wx1aa55cd86a285e0a', // 阅读好心情
  pro: 'wx1fbbaa6654693d53' // 叫叫儿童阅读
};
/**
 * jojoup小程序appid
 */
export const jojoupMiniappId = {
  test: 'wx0cf86b261e2591a6', // 叫叫鹦鹉学院
  pro: 'wx7d333995d9d7d2c3' // jojoup
};

/**
 * 小程序appid
 */
export const miniAppId = {
  jojo: DEBUG ? jojoMiniappId['test'] : jojoMiniappId['pro'], // 叫叫儿童阅读
  jojoup: DEBUG ? jojoupMiniappId['test'] : jojoupMiniappId['pro'] // jojoup
};

//
export default {
  MALL_BASE_URL,
  MALL_ORDER_PAY_URL,
  ORDER_BASE_URL,
  PAY_BASE_URL,
  DELIVERY_BASE_URL,
  REDEEMCODE_BASE_URL,
  COUPON_BASE_URL,
  AUTH_SIGN_URL,
  FE_BOOM_BASE_URL,
  FE_ACT_BASE_URL,
  EXCHANGE_CODE_ACTIVE_URL: process.env.EXCHANGE_URL || EXCHANGE_URL[`${envName}` || 'pro'],
  EXCHANGE_CODE_ACTIVE_JOJO_URL:
    process.env.EXCHANGE_JOJO_URL || EXCHANGE_JOJO_URL[`${envName}` || 'pro'],
  EXCHANGE_CODE_ACTIVED_URL:
    process.env.EXCHANGE_ACTIVED_URL || EXCHANGE_ACTIVED_URL[`${envName}` || 'pro'],
  UNBIND_URL: process.env.UNBIND_URL || UNBIND_URL[`${envName}` || 'pro'],
  envName,
  ADVERTISE_BASE_URL,
  UC_API_URL: DEBUG ? UC_DEBUG_API_DOMAIN : UC_API_DOMAIN,
  UC_BASE_API_URL: DEBUG ? UC_DEBUG_BASE_API_DOMAIN : UC_BASE_API_DOMAIN,
  CMS_DETAIL_URL: process.env.CMS_DETAIL_URL || CMS_DETAIL_URL[`${envName}` || 'pro'],
  BOOM_BASE_URL,
  SHINE_BASE_URL,
  NEW_SHINE_BASE_URL,
  CASHBACK_BASE_URL,
  QUOTA_BASE_URL,
  MALL_ORDER_BASE_URL,
  JING_TAN_NO_AUTH_URL,
  JING_TAN_NEED_AUTH_URL,
  AB_TEST_BASE_URL
};
